import "./SinglePostTemplate.module.css"
import Encabezado from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import PieDePágina from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Encabezado />
      <SinglePostTemplateSection />
      <PieDePágina />
    </div>
  )
}
